import React, { useEffect, useState } from 'react';

import Thumbnails from 'components/thumbnails/Thumbnails';
import usePublicApi from 'public-api';

type Props = {
  value: UUIDField[];
};

function FileUploadFieldValueWrapper({ value }: Props) {
  const [fileUploads, setFileUploads] = useState<BackendPublic.FileUpload[]>([]);
  const api = usePublicApi();

  useEffect(() => {
    const fetchFileUploads = async () => {
      const response = await Promise.all(value.map((fileId: UUIDField) => api.FilesFilesApi.retrieve({ id: fileId })));
      return response;
    };

    if (value) {
      (async () => {
        const fetchedFileUploads = await fetchFileUploads();
        setFileUploads(fetchedFileUploads);
      })();
    }
  }, [api.FilesFilesApi, value]);

  return <Thumbnails fileUploads={fileUploads} />;
}

export default FileUploadFieldValueWrapper;
